import styled from 'styled-components';

export const CampaignsStyled = styled.div`
    background: var(--color-surface);
    border-top: 1px solid var(--color-main);

    .accordion,
    .accordion-button {
        background: none;
        border: none;
    }

    .accordion-button {
        padding: var(--space-4);
    }

    .accordion-body {
        padding: 0 var(--space-4) var(--space-4);
    }
`;

export const CampaignsHeaderStyled = styled.div`
    display: flex;
    flex: 1;
    align-items: center;
    justify-content: space-between;
    gap: var(--space-3);

    h3 {
        margin: 0;
        font-size: var(--font-size-base);
        font-weight: 600;
        color: var(--color-white-95);
    }
`;

export const CampaignsTableStyled = styled.table`
    width: 100%;
    background: var(--color-surface-secondary);
    border-radius: var(--radius-md);
    overflow: hidden;

    tr {
        display: flex;
        width: 100%;
        align-items: center;
        padding: var(--space-4);
        gap: var(--space-2);
    }

    tbody tr {
        border-top: 1px solid var(--color-surface);
    }

    th {
        font-weight: 400;
        color: var(--color-white-60);
        font-size: var(--font-size-md);
    }

    .name {
        flex-basis: 20%;
    }

    .channel {
        flex-basis: 20%;
    }

    .link {
        flex-basis: 54%;

        .copy-button {
            margin-left: var(--space-2);
        }
    }

    .control {
        flex-basis: 6%;
        display: flex;
        justify-content: flex-end;
    }

    .edit {
        color: var(--color-accent);
        margin-right: calc(-1 * var(--space-4));
    }
`;
